module.exports = __webpack_public_path__ + "images/b164c8bafbda1d0df2ef5624be4302c8.svg";